import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addUserActivity } from "../../../../redux/actions/profileDetails";
import { createLeadScore } from "../../../../redux/actions/pricing";
import { Mixpanel } from "../../../../config/Mixpanel";
import Constants, { leadScoringActivity, userActivity } from "../../../../common/constants";
import { useNavigate } from "react-router-dom";
import { getLeads } from "../../../../redux/actions/userSubscription";

const PriceButton = ({ activePlanButtons,activeChildButton, setActiveChildButton, activeChildProduct , activeCard ,bookingProduct, razorpayHandler, setDowngradeModal,setIsCheckModal,maxData,
  setDefaultSticky}) => {
  
  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const isEligible = useSelector(
    (store) => store?.userSubscription?.isEligibleForLearntubeMax
  );
  const isBlocked = useSelector(store=> store?.userActivity?.user_trial_blocked);
  const user_id = useSelector(store=> store?.profileDetails?.id)
  const email = useSelector((store) => store?.profileDetails?.email);
  const dispatch = useDispatch();
  const [spinner1 , setSpinner1] = useState(false);
  const [spinner2 , setSpinner2] = useState(false);
  const navigate = useNavigate();
  const role_type = useSelector(store => store?.userSubscription?.role_type);

  useEffect(() => {
    switch (activeCard?.plan_name) {
      case "LearnTube Pro": {
        if (activeCard?.is_active_plan) {
          let isActiveChild = activePlanButtons?.[1];
          setActiveChildButton((prev) => ({
            ...prev,
            first: isActiveChild?.state_buttons?.[0],
            second: {},
          }));
        } else {
          let defaultChild = activePlanButtons?.[0];

          setActiveChildButton((prev) => ({
            ...prev,
            first: defaultChild?.state_buttons?.[0],
            second: {},
          }));
        }
        break;
      }
      case "LearnTubeX": {
        if (activeCard?.is_active_plan) {
          let isActiveChild = activePlanButtons?.[1];
          setActiveChildButton((prev) => ({
            ...prev,
            first: isActiveChild?.state_buttons?.[0],
            second: {},
          }));
        } else {
          let defaultChild = activePlanButtons?.[0];

          setActiveChildButton((prev) => ({
            ...prev,
            first: defaultChild?.state_buttons?.[0],
            second: {},
          }));
        }
        break;
      }
      case "LearnTube Max": {
        if (user_role === 7) {
          let isTrailChild = activePlanButtons?.[2];
          setActiveChildButton((prev) => ({
            ...prev,
            first: isTrailChild?.state_buttons?.[0],
            second: {},
          }));
        } else if (activeCard?.is_active_plan) {
          let isActiveChild = activePlanButtons?.[3];
          setActiveChildButton((prev) => ({
            ...prev,
            first: isActiveChild?.state_buttons?.[0],
            second: {},
          }));
        } else if (isEligible) {
          let isEligible = activePlanButtons?.[1];

          setActiveChildButton((prev) => ({
            ...prev,
            first: isEligible?.state_buttons?.[0],
            second: isEligible?.state_buttons?.[1],
          }));
        } else {
          let defaultChild = activePlanButtons?.[0];

          setActiveChildButton((prev) => ({
            ...prev,
            first: defaultChild?.state_buttons?.[0],
            second: {},
          }));
        }
        break;
      }
      case "Downgrade": {
        if (user_role === 7) {
          let isTrailChild = activePlanButtons?.[1];
          setActiveChildButton((prev) => ({
            ...prev,
            first: isTrailChild?.state_buttons?.[0],
            second: {},
          }));
        } else {
          let defaultChild = activePlanButtons?.[0];

          setActiveChildButton((prev) => ({
            ...prev,
            first: defaultChild?.state_buttons?.[0],
            second: {},
          }));
        }
        break;
      }

      default:
        break;
    }
  }, [activePlanButtons,isEligible]);

  const spinner = ()=>{
    return (
      <div className={`w-8 h-8 rounded-full border-4 border-[${activeCard?.plan_color_primary}] border-t-transparent animate-spin`}>
      </div>
    )
  }
  //console.log(getRandomArbitary() , 'day')
  function createLeadsForCards() {
    dispatch(
      addUserActivity(user_id, userActivity.PAYMENT_ATTEMPT, "", false, null)
    );
    setTimeout(()=>{

      dispatch(
        getLeads({
          user_id: user_id ? user_id : 0,
          user_plan: role_type ? role_type : "basic",
          product_id: activeChildProduct?.products_id,
          product_name: activeCard?.plan_name,
          product_type: "subscription",
          is_visit: false,
        })
      );

    },3000)
   

    switch (activeCard?.plan_name) {
      case "LearnTube Pro":
        {
          dispatch(
            createLeadScore(user_id, leadScoringActivity.CLICKED_LTPRO.type)
          );

          Mixpanel.track(Constants.Mixpanel.CLICKED_LTPRO, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTube Pro+":
        {
          dispatch(
            createLeadScore(user_id, leadScoringActivity.CLICKED_LTPROPLUS.type)
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTPROPLUS, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTubeX":
        {
          dispatch(
            createLeadScore(user_id, leadScoringActivity.CLICKED_LTX.type)
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTX, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTube Max": {
        dispatch(
          createLeadScore(user_id, leadScoringActivity.CLICKED_LTMAX.type)
        );
        Mixpanel.track(Constants.Mixpanel.CLICKED_LTMAX, {
          distinct_id: email,
        });
      }
      default:
        break;
    }
  }

  function getRandomArbitary() {
    const d = new Date();
    let day = d.getDay();

    if(day === 0)
    return 1;
    else
    return 8 - day
  

   }

   function firstButtonClick(e){

    if(user_id === 0 || user_id === null || user_id === undefined){
      navigate('/login');
      return;
    }
     if(activeCard?.plan_name === "LearnTube Max" && !isEligible && user_role !== 7 ){
      setIsCheckModal(true);
    }
    else if(activeCard?.plan_name === "Downgrade" && isBlocked){
      setDowngradeModal(true);
    }
    else{
      setSpinner1(true);
      razorpayHandler(activeChildProduct?.products_id,()=> setSpinner1(false));
    }
   }

   function secondButtonClick(e){
    if(user_id === 0 || user_id === null || user_id === undefined){
      navigate('/login');
      return;
    }
    setSpinner2(true);
    razorpayHandler(bookingProduct?.id,()=> setSpinner2(false))
   }
  
  // console.log(activeChildButton, "plan");
  if (
    activeCard?.plan_name === "LearnTube Pro" ||
    activeCard?.plan_name === "LearnTubeX"
  ) {
    return (
      <div className="w-full md:w-1/2">
        <button
          className="mt-4 w-full rounded-lg py-2 text-md text-white flex flex-col justify-center items-center "
          style={{
            background:
              activeChildButton?.first?.button_type === "gradient" &&
              `linear-gradient(418deg, ${activeCard?.plan_color_primary} 16.15%, ${activeCard?.plan_color_secondary} 86.12%)`,
          }}
          onClick={(e)=> {firstButtonClick(e); createLeadsForCards()}}
        >
          {spinner1 ? spinner() : activeChildButton?.first?.button_primary_text}
        </button>
      </div>
    );
  } else if (activeCard?.plan_name === "LearnTube Max") {
    if (_.isEmpty(activeChildButton?.second) && activeChildButton?.first?.button_secondary_text === "") {
      return <div className="w-full md:w-1/2">
       <button
          className="flex flex-col justify-center items-center mt-4 w-full rounded-lg py-2 text-white"
          style={{
            background:
              activeChildButton?.first?.button_type === "gradient" &&
              `linear-gradient(418deg, ${activeCard?.plan_color_primary} 16.15%, ${activeCard?.plan_color_secondary} 86.12%)`,
          }}
          onClick={(e)=> {firstButtonClick(e);createLeadsForCards()}}
        >
          {spinner1 ? spinner() : activeChildButton?.first?.button_primary_text}
        </button></div>
    } 
    else if(_.isEmpty(activeChildButton?.second))
    {
      return <div className="w-full md:w-1/2">
       <button
          className="flex flex-col justify-center items-center mt-4 w-full rounded-lg py-1 text-white"
          style={{
            background:
              activeChildButton?.first?.button_type === "gradient" &&
              `linear-gradient(418deg, ${activeCard?.plan_color_primary} 16.15%, ${activeCard?.plan_color_secondary} 86.12%)`,
          }}
          onClick={(e)=> {firstButtonClick(e);createLeadsForCards()}}
        >
          {spinner1 ? spinner() : <><div className="text-sm">{activeChildButton?.first?.button_primary_text}</div>
          <div className="text-supertiny">{(activeChildButton?.first?.button_secondary_text)?.replace('7',getRandomArbitary())}</div></>
        }
        </button>
      </div>
    }
    else {
      return <div className="w-full flex md:w-1/2">
      <button
          className="flex flex-col justify-center items-center mt-4 w-1/2 mr-1 rounded-lg py-1 text-white"
          style={{
            background:
              activeChildButton?.first?.button_type === "gradient" &&
              `linear-gradient(418deg, ${activeCard?.plan_color_primary} 16.15%, ${activeCard?.plan_color_secondary} 86.12%)`,
          }}
          onClick={(e)=> {firstButtonClick(e);createLeadsForCards();}}
        >
          { spinner1 ? spinner() : <><div className="text-sm">{activeChildButton?.first?.button_primary_text}</div>
          <div className="text-[10px]">Only {getRandomArbitary()} Seats Remaining</div>
          </>
        }
        </button>
        <button
          className={`flex flex-col justify-center items-center mt-4 w-1/2 ml-1 rounded-lg py-1 ${activeChildButton?.second?.button_type === 'border' ?  `text-[${activeCard?.plan_color_primary}] border-2 border-[${activeCard?.plan_color_primary}]` : 'text-white'}`}
          style={{
            background:
              activeChildButton?.second?.button_type === "gradient" &&
              `linear-gradient(418deg, ${activeCard?.plan_color_primary} 16.15%, ${activeCard?.plan_color_secondary} 86.12%)`,
          }}
          onClick={(e)=> {secondButtonClick(e);createLeadsForCards()}}
        >
          { spinner2 ? spinner() : <><div className="text-sm">Reserve Seat(₹{bookingProduct?.cost})</div>
          <div className="text-supertiny">Pay &#x20B9; {activeCard?.plan_products?.[0]?.cost_details?.final_cost_total - bookingProduct?.cost + 100} in 30 days</div>
          </>}
        </button></div>;
    }
  } else {
    return <div className="w-full md:w-1/2">
    <button
       className={`flex flex-col justify-center items-center mt-4 w-full rounded-lg py-1 font-medium text-black border-2 border-black disabled:opacity-[46%]`}
       disabled={user_role === 7 || !isBlocked}
       onClick={(e)=> {firstButtonClick(e); createLeadsForCards()}}
       style={{
         background:
           activeChildButton?.first?.button_type === "gradient" &&
           `linear-gradient(418deg, ${activeCard?.plan_color_primary} 16.15%, ${activeCard?.plan_color_secondary} 86.12%)`,
       }}
     >
       <div className="text-sm">{activeChildButton?.first?.button_primary_text}</div>
       <div className="text-supertiny">{activeChildButton?.first?.button_secondary_text}</div>
     </button>
   </div>
  }
};

export default PriceButton;
